(() => {
  const CUTOFF_HOUR = 15; // 3pm

  function formatDate(date) {
    return date.toLocaleDateString("en-GB", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
  }

  function addDispatchDays(date, days) {
    const d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) days--; // skip Sunday
    }
    return d;
  }

  function nextCutoff(now) {
    const d = new Date(now);
    const cutoff = new Date(d);
    cutoff.setHours(CUTOFF_HOUR, 0, 0, 0);

    // Sunday or after cutoff → next dispatch day
    if (d.getDay() === 0 || d > cutoff) {
      do {
        cutoff.setDate(cutoff.getDate() + 1);
      } while (cutoff.getDay() === 0);
    }

    return cutoff;
  }

  function render(box) {
    const target = box.querySelector(".wt-delivery-estimate__primary-text");
    if (!target) return;

    const now = new Date();
    const cutoff = nextCutoff(now);
    const deliveryBy = addDispatchDays(cutoff, 2);

    target.innerHTML = `
      <strong>Order now</strong> for UK delivery by ${formatDate(deliveryBy)}
    `;
  }

  function init() {
    const box = document.querySelector(".wt-delivery-estimate");
    if (!box) return;

    render(box);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
